module.exports = __webpack_public_path__ + "media/images/marketing/groupicon-f9e26c9d3fd67049d8823a07009b4d83ffc9344978deb56f5fcbfab803e89345.png";